import styles from '@styles/SingleBoat/overview_anchor.module.scss';
import { Anchor } from 'antd';
import type { AnchorLinkItemProps } from 'antd/es/anchor/Anchor';
import { ArrowRight } from 'lucide-react';
import React from 'react';
import type { BoatTableProps } from './boatMenus';

type Props = {
  details: BoatTableProps;
  jumbotronHeight: number;
};

const OverviewAnchor: React.FC<Props> = ({ details, jumbotronHeight }) => {
  const anchorItems: AnchorLinkItemProps[] = details
    .filter((item) => !!item && typeof item.link === 'string' && Array.isArray(item.menu))
    .map((item) => ({
      key: item.link,
      href: `#${item.link}`,
      title: <span>{item.title}</span>,
      className: styles.container__menu__item,
      children: item.menu
        .filter((subItem) => !!subItem && typeof subItem.link === 'string')
        .map((subItem) => ({
          key: subItem.link,
          href: `#${subItem.link}`,
          title: subItem.title,
          className: styles.container__sub_menu__item,
        })),
    }));

  return (
    <div className={styles.container}>
      <h3 className={styles.container__title}>Overview</h3>
      <Anchor affix={false} targetOffset={jumbotronHeight} items={anchorItems} />
    </div>
  );
};

export default OverviewAnchor;
